import cx from "classnames";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { CommunityService } from "../_service";
import { setCommunityLinksAction } from "../_store/community-links.store";
import I18 from "./atoms/i18";
import { CreateCommunityLinkModal } from "./community/create-link-modal";
import IconMenu2 from "./icon-menu-2.component";
import { Loader } from "./loader.component";
import { useAppService } from "../hooks/use-app-service";

function CommunityLinksComponent({
  // props
  navLinkMode = false, // this ensured it is visible to admin, or to user only in mobile view
  hideOnMobile = false, // used to remove lower instance
  // state
  community,
  user,
  links,
  // dispatch
  setLinks,
  // other
  addToast,
}) {
  // const [links, setLinks] = useState([]);
  const [selectedLink, setSelectedLink] = useState(null);

  const [processingId, setProcessingId] = useState(null);
  const [isCreateLinkModalVisible, setIsCreateLinkModalVisible] =
    useState(false);

  const { analyticsService } = useAppService();

  const triggerLinkClickEvent = (linkUrl) => {
    analyticsService.track('quick-link-click-sidebar', {
      linkUrl
    })
  }

  // when a new link is added
  const onLinkAdd = (link) => {
    setLinks([...links, link]);
  };

  // when a link is updated
  const onLinkUpdate = (link) => {
    const newLinks = [...links];
    const linkIndexToBeUpdated = newLinks.findIndex((l) => l.id === link.id);
    if (linkIndexToBeUpdated > -1) {
      newLinks.splice(linkIndexToBeUpdated, 1, link);
      setLinks(newLinks);
    }
  };

  // when a link is deleted
  const onLinkDelete = (link) => {
    const newLinks = [...links];
    const linkIndexToBeRemoved = newLinks.findIndex((l) => l.id === link.id);
    console.log({ linkIndexToBeRemoved });
    if (linkIndexToBeRemoved > -1) {
      newLinks.splice(linkIndexToBeRemoved, 1);
      setLinks(newLinks);
    }
  };

  const communityId = community?.id;

  // load other links
  useEffect(() => {
    if (community) {
      CommunityService.getCommunityLinks(communityId)
        .then(({ links }) => {
          setLinks(links);
        })
        .catch((error) => {
          console.log({ error });
          addToast(
            "Community Links could not be loaded!",
            "",
            ToastTypes.danger
          );
        });
    }
  }, [communityId]);

  // show nothing if there are no links
  if (community && community.myRole !== "admin" && links.length === 0) {
    return <></>;
  }

  return (
    <div
      className={cx({
        block: !navLinkMode, // show everytime if not in navlink mode
        "mobile-only": navLinkMode,
        "mobile-hidden": hideOnMobile,
      })}>
      {/* create links button, show for admin only and in normal mode */}
      {!navLinkMode || community?.myRole === "admin" ? (
        <div className="flex items-center pl-6 justify-between py-3">
          <div className="uppercase theme-text-heading-2 font-semibold pr-3">
            <I18>Links</I18>
          </div>
          {community && user && community.myRole === "admin" ? (
            <CreateLinkButton
              isCreateGroupModalVisible={isCreateLinkModalVisible}
              setIsCreateGroupModalVisible={setIsCreateLinkModalVisible}
            />
          ) : (
            <></>
          )}
        </div>
      ) : (
        <div className="my-3 border-t theme-border-default" />
      )}
      <div className="CommunityLinks rounded px-2 mb-5">
        {links.map((link) => (
          <a
            className="theme-text-default flex items-center justify-between hover:theme-bg-default px-4 rounded"
            key={link.id}
            target="_blank"
            href={link.url}
            rel="noopener noreferrer"
            onClick={() => triggerLinkClickEvent(link.url)}
            title={link.label}>
            {/* {link.emoji ? link.emoji : "#"}{" "} */}
            {link.label.length > 17
              ? link.label.substr(0, 17) + "..."
              : link.label}
            {/* show owner options */}
            {community && community.myRole === "admin" ? (
              processingId === link.id ? (
                <div style={{ transform: "scale(0.5)" }}>
                  <Loader />
                </div>
              ) : (
                <>
                  <IconMenu2
                    icon="menu-dots"
                    actions={[
                      {
                        icon: "share",
                        label: "Edit",
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setSelectedLink(link);
                          setIsCreateLinkModalVisible(true);
                        },
                      },

                      {
                        icon: "trash",
                        label: "Delete",
                        labelClass: "theme-text-danger",
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setProcessingId(link.id);
                          // delete the link
                          CommunityService.deleteCommunityLink(
                            user,
                            community.id,
                            link
                          )
                            .then(({ link }) => {
                              // remove the link
                              onLinkDelete(link);
                            })
                            .catch((error) => {
                              console.log({ error });
                              addToast(
                                "Could not be deleted!",
                                "",
                                ToastTypes.danger
                              );
                              setProcessingId(null);
                            });
                        },
                        actionType: "alert",
                      },
                    ]}
                  />
                </>
              )
            ) : (
              <div className="my-2">&nbsp;</div>
            )}
          </a>
        ))}
      </div>
      {/* community link modal */}
      {isCreateLinkModalVisible ? (
        <CreateCommunityLinkModal
          user={user}
          community={community}
          active={isCreateLinkModalVisible}
          setActive={(status) => {
            if (!status) {
              setIsCreateLinkModalVisible(false);
              if (selectedLink) {
                setSelectedLink(null);
              }
            }
          }}
          link={selectedLink}
          onLinkAdd={onLinkAdd}
          onLinkUpdate={onLinkUpdate}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

const CommunityLinks = withToast(
  connect((s) => ({ user: s.auth, community: s.community }))(
    CommunityLinksComponent
  )
);

const stp = (state) => ({
  links: state.communityLinks.links,
});

const dtp = {
  setLinks: setCommunityLinksAction,
};

export default connect(stp, dtp)(CommunityLinks);

/**
 * Create group button
 * @param {*} param0
 * @returns
 */
function CreateLinkButton({
  onGroupCreate = (group) => {},
  isCreateGroupModalVisible = false,
  setIsCreateGroupModalVisible = (e) => {},
}) {
  return (
    <div
      onClick={(e) => {
        setIsCreateGroupModalVisible(true);
      }}
      className="flex items-center justify-center rounded-full  hover:shadow h-10 w-10 cursor-pointer">
      <div className="border flex items-center p-1 h-4 w-4  rounded theme-border-subtitle-1 place-content-center">
        <i className="fi-rr-plus-small text-sm"></i>
      </div>
    </div>
  );
}
